export default __webpack_public_path__ + "static/media/kriteria-monitoring.3397ac38.png";